'use client';

import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { usePathname, useRouter } from '@/i18n/routing';

interface AssetsPageClientProps {
  children: ReactNode;
}

export const AssetsPageClient = ({ children }: AssetsPageClientProps) => {
  const t = useTranslations();
  const router = useRouter();
  const pathname = usePathname();

  const options = useMemo(
    () => [
      { href: '/assets/mycreations', label: t('sidebar.assetsItems.creations') },
      { href: '/assets/myreferences', label: t('sidebar.assetsItems.elements') },
      { href: '/assets/liverecords', label: t('sidebar.assetsItems.liveRecords') },
    ],
    [t],
  );

  return (
    <div className="flex h-full flex-col">
      <div className="sticky top-0 z-10 mb-2 border-system-white08 border-b bg-system-bg01 py-3">
        <div className="flex items-center gap-5">
          {options.map((option) => {
            const isActive = pathname === option.href || pathname.startsWith(`${option.href}/`);

            return (
              <button
                key={option.href}
                type="button"
                className={`relative whitespace-nowrap pb-1 text-sm transition-colors ${
                  isActive ? 'font-medium text-white' : 'text-system-white64 hover:text-system-white80'
                }`}
                onClick={() => {
                  router.replace(option.href);
                }}
              >
                {option.label}
                {isActive && <span className="-bottom-1 absolute left-0 h-[2px] w-full rounded-full bg-white" />}
              </button>
            );
          })}
        </div>
      </div>
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
};
